import { useState, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Drawer } from "antd";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import SideBar from "./components/side-navigation/SideNav";
import { FallbackProvider } from "./context/fallBackContext/fallBackContextProvider";

// Lazy loading components
const LandingPage = lazy(() => import("./views/landing/LandingPage"));
const SignUp = lazy(() => import("./views/signup/SignUp"));
const Login = lazy(() => import("./views/login/Login"));
const Pricing = lazy(() => import("./views/pricing/Pricing"));
const ContactSales = lazy(() => import("./views/contact-sales/ContactSales"));
const ApiStatus = lazy(() => import("./views/api-status/ApiStatus"));
const Product = lazy(() => import("./views/products/Product"));
const Jobs = lazy(() => import("./views/jobs/Jobs"));
const Guide = lazy(() => import("./views/guide/Guide"));
const PaymentLink = lazy(() => import("./views/payment-link/PaymentLink"));
const Swop = lazy(() => import("./views/swop/Swop"));
const DirectDebit = lazy(() => import("./views/direct-debit/DirectDebit"));
const Checkout = lazy(() => import("./views/checkout/Checkout"));
const Compliance = lazy(() => import("./views/compliance/Compliance"))

function App() {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {

    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);

  };

  return (
    <BrowserRouter>
      <FallbackProvider>
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <LandingPage
                open={open}
                showDrawer={showDrawer}
                onClose={onClose}
              />
            }
          />
          {/* <Route path="/login" element={<Login />} /> */}
          {/* <Route path="/signup" element={<SignUp />} /> */}
          <Route
            path="/pricing"
            element={
              <Pricing open={open} showDrawer={showDrawer} onClose={onClose} />
            }
          />
          <Route
            path="/contact-sales"
            element={
              <ContactSales
                showDrawer={showDrawer}
                open={open}
                onClose={onClose}
              />
            }
          />
          <Route path="/api-status" element={<ApiStatus />} />
          <Route
            path="/jobs"
            element={
              <Jobs open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
          <Route
            path="/invoice"
            element={
              <Product open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
          <Route
            path="/guide"
            element={
              <Guide open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
           <Route
            path="/compliance"
            element={
              <Compliance open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
          <Route
            path="/payment-link"
            element={
              <PaymentLink
                open={open}
                onClose={onClose}
                showDrawer={showDrawer}
              />
            }
          />
          <Route
            path="/swop"
            element={
              <Swop open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
          <Route
            path="/direct-debit"
            element={
              <DirectDebit
                open={open}
                onClose={onClose}
                showDrawer={showDrawer}
              />
            }
          />
          <Route
            path="/checkout"
            element={
              <Checkout open={open} onClose={onClose} showDrawer={showDrawer} />
            }
          />
        </Routes>
        <Drawer
          title={false}
          width={"90%"}
          closable={true}
          onClose={onClose}
          open={open}
          placement="right"
        >
          <SideBar />
        </Drawer>
      </FallbackProvider>
    </BrowserRouter>
  );
}

export default App;
